<nav aria-label="Stage navigation" data-testid="sidebar-nav" class="sidebar-nav">
  <div class="sidebar-header">
    <!-- AZ Logo: text fallback per tech-lead RECOMMENDED #2 -->
    <span class="az-logo-text" aria-hidden="true">AZ</span>
    <!-- TODO: Replace with az-logo-white.svg when AZ brand asset is sourced -->
    @if (!collapsed()) {
      <span class="app-name">AZ Symphony</span>
    }
  </div>

  <ul class="stage-list" role="list">
    @for (stage of stages; track stage.name; let i = $index) {
      <li>
        <button
          class="stage-btn"
          [class.active]="activeIndex() === i"
          [attr.aria-current]="activeIndex() === i ? 'page' : null"
          [attr.aria-label]="stage.name"
          (click)="onStageSelect(i)"
          [attr.data-testid]="'stage-item-' + i"
          type="button">
          <mat-icon class="stage-icon" [class.active]="activeIndex() === i">
            {{ stage.icon }}
          </mat-icon>
          @if (!collapsed()) {
            <span class="stage-label">{{ stage.name }}</span>
          }
        </button>
      </li>
    }
  </ul>
</nav>
